var vista = vista || {};
vista.Tag  = Class.extend(
    function(){
        /**
         * Nombre del tag
         * @type string
         */
        var thisTag;
        /**
         * Determina si el tag es de cierre o no
         * @type bool
         */
        var thisEsCierre;
        /**
         * HTML interno (opcional)
         * @type string
         */
        var thisHtml;
        /**
         * Lista de tags que no se deben envolver (abren y finalizan sobre el mismo tag)
         * @type Object
         */
        var thisTagsNoEnvolver= {"img":true,"input":true,"meta":true,"link":true,"br":true};
        /**
         * Lista de atributos
         * @type {Object}
         */
        var thisAtributos = {};

        this.constructor = function(sTag){
            thisTag = sTag;
            thisEsCierre = (sTag.charAt(0)=="/");
        };

        /**
         * Asigna el HTML interno al tag
         * @param {string} html HTML interno
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.html = function(html){
            if(thisEsCierre)
                throw "No se puede asignar el html interno sobre tags cerrados";
            else if(thisTagsNoEnvolver[thisTag] && html!==null)
                throw "No se puede asignar el html interno sobre el tag "+thisTag;
            if(!thisTagsNoEnvolver[thisTag])
                thisHtml = html.toString();
            return this;
        };

        /**
         * Incluye/sustituye un atributo en el tag
         * @param {string} nombre Nombre del atributo
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atr = function(nombre,valor){
            if(thisEsCierre)
                throw "No se pueden añadir atributos sobre tags cerrados";
            if(valor || thisAtributos[nombre]!=undefined || nombre=="value" || nombre.indexOf("data-")===0)
                thisAtributos[nombre] = valor;
            return this;
        };

        /**
         * Incluye/sustituye el atributo href en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrHref = function(valor){
            if(!valor)
                valor = "#";
            return this.atr("href",valor);
        };

        /**
         * Incluye/sustituye el atributo id en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrId = function(valor){
            return this.atr("id",valor);
        };

        /**
         * Incluye/sustituye el atributo name en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrName = function(valor){
            return this.atr("name",valor);
        };

        /**
         * Incluye/sustituye el atributo rows en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrRows = function(valor){
            return this.atr("rows",valor);
        };

        /**
         * Incluye/sustituye el atributo width en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrWidth = function(valor){
            return this.atr("width",valor);
        };

        /**
         * Incluye/sustituye el atributo height en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrHeight = function(valor){
            return this.atr("height",valor);
        };

        /**
         * Incluye/sustituye el atributo type en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrType = function(valor){
            return this.atr("type",valor);
        };

        /**
         * Incluye/sustituye el atributo autocomplete en el tag
         * @param {string} activar Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrAutocomplete = function(activar){
            if(!activar) //solo se añade el atributo si se desactiva
                return this.atr("autocomplete","off");
            else
                return this;
        };

        /**
         * Incluye/sustituye el atributo alt en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrAlt = function(valor){
            return this.atr("alt",valor);
        };

        /**
         * Incluye/sustituye el atributo title en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrTitle = function(valor){
            return this.atr("title",valor);
        };

        /**
         * Incluye/sustituye el atributo value en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrValue = function(valor){
            return this.atr("value",valor);
        };

        /**
         * Incluye/sustituye el atributo maxlength en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrMaxLength = function(valor){
            return this.atr("maxlength",valor);
        };

        /**
         * Incluye/sustituye el atributo placeholder en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrPlaceholder = function(valor){
            return this.atr("placeholder",valor);
        };

        /**
         * Incluye/sustituye el atributo class en el tag
         * @param {(string|css.Clase)} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrClass = function(valor){
            return this.atr("class",valor);
        };

        /**
         * Incluye/sustituye el atributo data-[nombre] en el tag
         * @param {string} nombre Nombre del atributo (se le añadirá "data-" delante)
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrData = function(nombre,valor){
            return this.atr("data-".nombre,valor);
        };

        /**
         * Incluye el atributo bool en el tag
         * @param {string} nombre Nombre del atributo bool
         * @param {bool} activar True si hay que activarlo, false en caso contrario
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrBool = function(nombre,activar){
            return this.atr(nombre,activar?nombre+"__bool":"");
        };

        /**
         * Incluye el atributo bool disabled en el tag
         * @param {bool} activar True si hay que activarlo, false en caso contrario
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrBoolDisabled = function(activar){
            return this.atrBool("disabled",activar);
        };

        /**
         * Incluye el atributo bool required en el tag
         * @param {bool} activar True si hay que activarlo, false en caso contrario
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrBoolRequired = function(activar){
            return this.atrBool("required",activar);
        };

        /**
         * Incluye el atributo bool checked en el tag
         * @param {bool} activar True si hay que activarlo, false en caso contrario
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrBoolChecked = function(activar){
            return this.atrBool("checked",activar);
        };

        /**
         * Incluye el atributo bool multiple en el tag
         * @param {bool} activar True si hay que activarlo, false en caso contrario
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrBoolMultiple = function(activar){
            return this.atrBool("multiple",activar);
        };

        /**
         * Incluye el atributo style en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrStyle = function(valor){
            return this.atr("style",valor);
        };

        /**
         * Incluye el atributo action en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrAction = function(valor){
            return this.atr("action",valor);
        };

        /**
         * Incluye el atributo target en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrTarget = function(valor){
            return this.atr("target",valor);
        };

        /**
         * Incluye el atributo enctype en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrEnctype = function(valor){
            return this.atr("enctype",valor);
        };

        /**
         * Incluye el atributo method en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrMethod = function(valor){
            return this.atr("method",valor);
        };

        /**
         * Incluye el atributo rel en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrRel = function(valor){
            return this.atr("rel",valor);
        };

        /**
         * Incluye el atributo for en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrFor = function(valor){
            return this.atr("for",valor);
        };

        /**
         * Incluye el atributo src en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrSrc = function(valor){
            return this.atr("src",valor);
        };

        /**
         * Incluye el atributo srcset en el tag
         * @param {string} valor Valor del atributo
         * @return {vista.Tag} Referencia a sí mismo
         */
        this.atrSrcset = function(valor){
            return this.atr("srcset",valor);
        };

        /**
         * Devuelve el tag abierto y todos los atributos asociados
         * @return string HTML generado
         */
        function abrir(){
            var html  = "<"+thisTag;
            for(var atrib in thisAtributos){
                var val = thisAtributos[atrib];
                html  += " ";
                if(atrib+"__bool"===val) //atributo booleano
                    html += atrib;
                else if(atrib=="value" || val!="" || atrib.indexOf("data-")===0)
                    html += atrib+'="'+val.toString()+'"';
            }
            if(thisTagsNoEnvolver[thisTag]) //tag especial que debe cerrarse
                html += " />";
            else
                html += ">";
            return html;
        }

        /**
         * Cierra el tag devolviendo el string asociado
         * @return {string} HTML generado
         */
        function cerrar(){
            return "</"+thisTag+">";
        }

        //Este método se comporta de forma diferente dependiendo del contenido
        this.toString = function(){
            if(thisEsCierre) //cierre de tag
                return "<"+thisTag+">";
            else{
                if(typeof thisHtml == "string")
                    return abrir()+thisHtml+cerrar();
                else
                    return abrir();
            }
        }
    }
);

/**
 * Crea un objeto vista.Tag nuevo
 * @param {string} sTag Nombre del tag
 * @param {string=} html Contenido HTML del tag (opcional)
 * @param {string=} clase Atributo class del tag (opcional)
 * @param {string=} id Atributo id del tag (opcional)
 * @param {...string=} adic Atributos adicionales
 * @return {vista.Tag}
 */
function tag(sTag,html,clase,id,adic){
    var obj = new vista.Tag(sTag);
    if(html!==undefined)
        obj.html(html);
    if(clase)
        obj.atrClass(clase);
    if(id)
        obj.atrId(id);
    for(var i=4;i<arguments.length;i+=2)
        obj.atr(arguments[i],arguments[i+1]);
    return obj;
}

/**
 * Crea un objeto vista.Tag nuevo con un <a>
 * @param {string} href Href
 * @param {string} texto Anchor text
 * @param {(string|css.Clase)=} clase Clase CSS
 * @param {string=} id Id
 * @param {string=} title Title
 * @param {string=} style Style
 * @param {bool=} nofollow Si viene a true, se añadirá rel="nofollow"
 * @return {vista.Tag}
 */
function tagA(href,texto,clase,id,title,style,nofollow){
    var t = tag("a");
    t.atrHref(href?href:"#");
    t.html(texto);
    if(title)
        t.atrTitle(title);
    if(id)
        t.atrId(id);
    if(clase)
        t.atrClass(clase);
    if(style)
        t.atrStyle(style);
    if(nofollow)
        t.atrRel("nofollow");
    return t;
}
